import * as React from "react";
import { ArrowDropDown, ArrowDropUp, Close } from "@material-ui/icons";
import {
  Box,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { useEffect } from "react";
import ApiClient from "utils/ApiClient";
import { useState } from "react";
import moment from "moment";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import styled from "styled-components";

export default function CollapsibleTable(props) {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openState, setOpenState] = useState({});
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [filter, setFilter] = useState({ operation: "", date: "", user: "", column: "" });
  const [filterOptions, setFilterOptions] = useState({ operation: [], user: [], column: [] });
  const [sheetNamesById, setsheetNamesById] = useState(
    Object.keys(window.appStore?.containerStores).reduce((acc, el) => {
      acc[el] = window.appStore?.containerStores[el].listConfig?.list?.name;
      return acc;
    }, {})
  )
  const [hanlderNamesById, setHanlderNamesById] = useState({})
  
  let fileColumn = [];
  props.data?.store?.columns?.forEach((el) => el.column_type_id == "9" && fileColumn.push(el.name));

  const comparator = (a, b) => {
    const dateA = a.CreatedAt;
    const dateB = b.CreatedAt;

    if (a.Operation != b.Operation) {
      if (a.Operation == "add-row") {
        return 1;
      } else {
        return -1;
      }
    }

    if (dateA > dateB) {
      return -1;
    }
    if (dateA < dateB) {
      return 1;
    }
    return 0;
  };

  const fetchLogs = async () => {
    setIsLoading(true);
    try {
      let row_id = props.data.data.row_id;
      let list_id = props.data.listId;
      let parent_row_id = "";
      let columnId = "";
      let isSubsheet = 0;
      if (props.data.isSubsheet) {
        list_id = props?.data?.context?.props?.parentListId;
        parent_row_id = props?.data?.context?.props?.rowId;
        columnId = props?.data?.context?.props?.columnId;
        isSubsheet = 1;
      }
      const resp = await ApiClient.List.getLogs({
        row_id: row_id,
        list_id: list_id,
        parent_row_id: parent_row_id,
        column_id: columnId,
        isSubsheet: isSubsheet,
      });
      if (resp.success) {
        setLogs(resp.formattedLogs.sort(comparator));
        setFilteredLogs(resp.formattedLogs.sort(comparator));
        let closeState = {};
        let tempFilterOptions = { operation: [], user: [], column: [] };
        let tempNamesById = {
          sheets: [],
          handlers: [],
        };
        resp.formattedLogs?.forEach(async (el, idx) => {
          closeState[idx] = idx == 0 ? true : false;
          if (!tempFilterOptions.operation.includes(el.Operation)) {
            tempFilterOptions.operation.push(el.Operation);
          }
          if (!tempFilterOptions.user.includes(el["Created By"])) {
            tempFilterOptions.user.push(el["Created By"]);
          }
          if (!tempFilterOptions.column.includes(el.ColumnNames) && el.ColumnNames != "") {
            tempFilterOptions.column.push(el.ColumnNames);
          }
          if (
            el.hasOwnProperty("AdditionalInfoObj") &&
            el.AdditionalInfoObj.hasOwnProperty("executed_in") &&
            el.AdditionalInfoObj.executed_in != ""
          ) {
            if(tempNamesById.sheets.indexOf(el.AdditionalInfoObj.executed_in) == -1){
              tempNamesById.sheets.push(el.AdditionalInfoObj.executed_in)
            }
          }
          if (
            el.hasOwnProperty("AdditionalInfoObj") &&
            el.AdditionalInfoObj.hasOwnProperty("handler_id") &&
            el.AdditionalInfoObj.handler_id != ""
          ) {
            if(tempNamesById.handlers.indexOf(el.AdditionalInfoObj.handler_id) == -1){
              tempNamesById.handlers.push(el.AdditionalInfoObj.handler_id)
            }
          }
        });
        setFilterOptions(tempFilterOptions);
        fetchNamesFromIds(tempNamesById);
        setOpenState(closeState);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };


  const fetchNamesFromIds = async (tempNamesById = { sheets: [], handlers: [] }) => {
    let sheets = [
      ...new Set(tempNamesById.sheets.filter((el) => !sheetNamesById.hasOwnProperty(el))),
    ];
    let handlers = tempNamesById.handlers;

    let sheetNames = {};
    let handlerNames = {};

    if (sheets.length > 0 || handlers.length > 0) {
      await Promise.all([
        ...(sheets.length > 0
          ? sheets.map(async (el) => {
              let sheetName = await getSheetName(el);
              sheetNames[el] = sheetName;
            })
          : []),
        ...(handlers.length > 0
          ? handlers.map(async (el) => {
              let handlerName = await getHandlerName(el);
              handlerNames[el] = handlerName || "DELETED";
            })
          : []),
      ]);
    }
    
    setsheetNamesById({
      ...sheetNamesById,
      ...sheetNames,
    });
    setHanlderNamesById({
      ...hanlderNamesById,
      ...handlerNames,
    });
  };

  const getSheetName = async (id) => {
    try {
      let resp = await ApiClient.List.getListConfig({
        list_id: id,
      });
      if (resp.success) {
        return resp.data.list.name;
      }
    } catch (error) {
      console.log(error);
    }
    return id;
  };

 const getHandlerName = async (id) => {
    try {
      let resp = await ApiClient.EventHandlers.getHandlerDetails({
        handler_id: id,
      });
      if (resp.success) {
        return resp.handler.name;
      }
    } catch (error) {
      console.log(error);
    }
    return id;
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const closeHandler = (id) => {
    setOpenState((prev) => {
      return { ...prev, [id]: false };
    });
  };

  const openHandler = (id) => {
    let newObj = {};
    logs.forEach((el, idx) => {
      if (idx == id) {
        newObj[id] = true;
      } else {
        newObj[idx] = false;
      }
    });
    setOpenState(newObj);
  };

  const changeHandler = (value, type) => {
    let newFilter = { ...filter, [type]: value ? value : "" };
    setFilter(newFilter);
    applyFilter(newFilter);
  };

  const applyFilter = (filter) => {
    let newFilteredLogs = logs.filter((el, idx) => {
      if (filter.operation.length > 0 && filter.operation != el.Operation) {
        return false;
      }
      if (filter.column.length > 0 && filter.column != el.ColumnNames) {
        return false;
      }
      if (filter.user.length > 0 && filter.user != el["Created By"]) {
        return false;
      }
      return true;
    });
    setFilteredLogs(newFilteredLogs);
  };

  const getAutoComplete = (options, type, placeholder) => {
    return (
      <Autocomplete
        id="size-small-outlined"
        size="small"
        options={options}
        onChange={(e, value) => changeHandler(value, type)}
        renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
        renderOption={(option) => (
          <Typography style={{ fontSize: ".8rem" }} variant="p">
            {option}
          </Typography>
        )}
      />
    );
  };

  return (
    <div>
      <StyledDiv>
        <Typography style={{ fontSize: "1.6rem" }}> History </Typography>
        <IconButton onClick={props.closePopper}>
          <Close />
        </IconButton>
      </StyledDiv>
      <StyledTableContainer component={Paper}>
        {isLoading ? (
          <StyledProgress>
            <CircularProgress />
          </StyledProgress>
        ) : logs.length > 0 ? (
          <Table stickyHeader aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>
                  Operation
                  {getAutoComplete(filterOptions.operation, "operation", "Operations")}
                </TableCell>
                <TableCell align="left">executed on</TableCell>
                <TableCell align="left">
                  by
                  {getAutoComplete(filterOptions.user, "user", "User")}
                </TableCell>
                <TableCell align="left">
                  on column
                  {getAutoComplete(filterOptions.column, "column", "Column")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredLogs.length > 0 &&
                filteredLogs.map((row, index) => (
                  <Row
                    key={Math.random()}
                    row={row}
                    fileColumn={fileColumn}
                    index={index}
                    open={openState[index]}
                    closeHandler={closeHandler}
                    openHandler={openHandler}
                    sheetNamesById={sheetNamesById}
                    hanlderNamesById={hanlderNamesById}
                  />
                ))}
            </TableBody>
          </Table>
        ) : (
          <StyledNoLogsFound>Logs not found</StyledNoLogsFound>
        )}
      </StyledTableContainer>
    </div>
  );
}

function Row(props) {
  const { row, open, closeHandler, openHandler, index, sheetNamesById, hanlderNamesById } = props;
  const istDate = new Date(row.CreatedAt);
  const finalDate = window.appStore.containerStore.currentViewStore.convertIstToCurrentTimeZone(istDate)
  const getFileExtension = (file) => {
    const fileNameArray = (file ?? ".x").split(".");
    return fileNameArray[fileNameArray.length - 1];
  };

  const openAllExceptThis = () => {
    if (open) {
      closeHandler(index);
    } else {
      openHandler(index);
    }
  };

  const [style, setStyle] = useState(false);
  const AdditionalInfoRenderer = ({ data }) => {
    switch (data.type) {
      case "handler":
        let sheetName = sheetNamesById[data["executed_in"]] + " (" + data["executed_in"] + ")";
        let handlerName =
          data["handler_id"] !== "" && hanlderNamesById.hasOwnProperty(data["handler_id"]) && hanlderNamesById[data["handler_id"]] !== ""
            ? hanlderNamesById[data["handler_id"]] + " (" + data["handler_id"] + ")"
            : data["handler_id"];
        return (
          <div style={{ fontSize: ".9rem" }}>
            <div>Executed in sheet : {sheetName}</div>
            <div>Executed on event : {data["event"]} </div>
            <div>Executed on row : {data["executed_by_row"]} </div>
            <div>Handler/Id : {handlerName}</div>
            {(data.email && data.email != "") ? <div>Executed by user : {data["email"]}</div> : <div>User Id : {data['user']}</div> }
          </div>
        );
      case "form":
        return (
          <div style={{ fontSize: ".9rem" }}>
            <div>Row added by form : {data.form_id}</div>
          </div>
        );
      default:
        return <div style={{ fontSize: ".9rem" }}>Additional info not found</div>;
    }
  };

  return (
    <React.Fragment>
      <TableRow
        style={{
          backgroundColor: open || style ? "#EBEBEB" : "",
          minWidth: "590px",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          cursor: "pointer",
        }}
        onMouseEnter={() => setStyle(true)}
        onMouseLeave={() => setStyle(false)}
        onClick={() => openAllExceptThis()}
      >
        <TableCell>
          <IconButton aria-label="expand row" size="small">
            {open ? <ArrowDropUp /> : <ArrowDropDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.Operation}
        </TableCell>
        <Tooltip title={moment(finalDate).format("DD-MMM-YY HH:mm a")}>
          <TableCell align="left">{moment(finalDate).fromNow()}</TableCell>
        </Tooltip>
        {row.AdditionalInfoObj && Object.keys(row.AdditionalInfoObj).length > 0 ? (
          <Tooltip
            title={
              <AdditionalInfoRenderer data={row.AdditionalInfoObj} />
            }
          >
            <StyledTableCell>{row["Created By"]}</StyledTableCell>
          </Tooltip>
        ) : (
          <TableCell align="left">{row["Created By"]}</TableCell>
        )}
        <TableCell align="left">{row.ColumnNames}</TableCell>
      </TableRow>
      <TableRow style={{ backgroundColor: open ? "#EBEBEB" : "" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box style={{ maxWidth: "590px", overflow: "auto", marginLeft: "60px" }}>
              {row.Operation != "add-row" ? (
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Current Data</TableCell>
                      <TableCell align="left">Previous Data</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow key={Math.random()}>
                      {props.fileColumn?.includes(row.ColumnNames) ? (
                        <React.Fragment>
                          <TableCell align="left" component="th" scope="row">
                            {row.CurrentData?.split("\n").map((el) =>
                              ["jpg", "jpeg", "bmp", "gif", "png"].includes(
                                getFileExtension(el.replace(/,+$/, ""))
                              )
                                ? el.length > 0 && (
                                    <a
                                      href={el.replace(/,+$/, "")}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img
                                        src={el.replace(/,+$/, "")}
                                        alt={el.replace(/,+$/, "")}
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          objectFit: "contain",
                                          verticalAlign: "textTop",
                                        }}
                                      />
                                    </a>
                                  )
                                : el.length > 0 && (
                                    <a
                                      href={el.replace(/,+$/, "")}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <span
                                        alt={el.replace(/,+$/, "")}
                                        class={`fiv-sqo fiv-icon-blank fiv-icon-${getFileExtension(
                                          el.replace(/,+$/, "")
                                        )} file_icon_style`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          verticalAlign: "top",
                                        }}
                                      ></span>
                                    </a>
                                  )
                            )}
                          </TableCell>
                          <TableCell align="left" component="th" scope="row">
                            {row.PreviousData?.split("\n").map((el) =>
                              ["jpg", "jpeg", "bmp", "gif", "png"].includes(
                                getFileExtension(el.replace(/,+$/, ""))
                              )
                                ? el.length > 0 && (
                                    <a
                                      href={el.replace(/,+$/, "")}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img
                                        src={el.replace(/,+$/, "")}
                                        alt={el.replace(/,+$/, "")}
                                        style={{
                                          height: "100px",
                                          width: "100px",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </a>
                                  )
                                : el.length > 0 && (
                                    <a
                                      href={el.replace(/,+$/, "")}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <span
                                        alt={el.replace(/,+$/, "")}
                                        class={`fiv-sqo fiv-icon-blank fiv-icon-${getFileExtension(
                                          el.replace(/,+$/, "")
                                        )} file_icon_style`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          verticalAlign: "top",
                                        }}
                                      ></span>
                                    </a>
                                  )
                            )}
                          </TableCell>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <TableCell
                            align="left"
                            component="th"
                            scope="row"
                            dangerouslySetInnerHTML={{ __html: row.CurrentData }}
                            style={{ whiteSpace: "pre-line" }}
                          ></TableCell>
                          <TableCell
                            align="left"
                            dangerouslySetInnerHTML={{ __html: row.PreviousData }}
                            style={{ whiteSpace: "pre-line" }}
                          ></TableCell>
                        </React.Fragment>
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              ) : (
                row.CurrentDataObj && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {Object.keys(row.CurrentDataObj).map((key, idx) => {
                          return <TableCell align="left">{key}</TableCell>;
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow key={Math.random()}>
                        {Object.keys(row.CurrentDataObj).map((key, idx) => {
                          return props.fileColumn?.includes(key) ? (
                            <TableCell align="left" component="th" scope="row">
                              {row.CurrentDataObj[key]?.split("\n").map((el) =>
                                ["jpg", "jpeg", "bmp", "gif", "png"].includes(getFileExtension(el))
                                  ? el.length > 0 && (
                                      <a
                                        href={el.replace(/,+$/, "")}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <img
                                          src={el.replace(/,+$/, "")}
                                          alt={el.replace(/,+$/, "")}
                                          style={{
                                            height: "100px",
                                            width: "100px",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </a>
                                    )
                                  : el.length > 0 && (
                                      <a
                                        href={el.replace(/,+$/, "")}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <span
                                          alt={el.replace(/,+$/, "")}
                                          class={`fiv-sqo fiv-icon-blank fiv-icon-${getFileExtension(
                                            el.replace(/,+$/, "")
                                          )} file_icon_style`}
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            verticalAlign: "top",
                                          }}
                                        ></span>
                                      </a>
                                    )
                              )}
                            </TableCell>
                          ) : (
                            <TableCell
                              align="left"
                              component="th"
                              scope="row"
                              dangerouslySetInnerHTML={{ __html: row.CurrentDataObj[key] }}
                              style={{ whiteSpace: "pre-line" }}
                            ></TableCell>
                          );
                        })}
                      </TableRow>
                    </TableBody>
                  </Table>
                )
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 15px 0px 15px;
  background-color: white;
  border-radius: 5px;
`;

const StyledTableContainer = styled(TableContainer)`
  height: 50vh;
  padding: 0px 5px 5px 5px;
  min-width: 700px;
`;

const StyledProgress = styled.div`
  width: 700px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledNoLogsFound = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledTableCell = styled(TableCell)`
  align: left;
  text-decoration: underline dotted #3f51b5 1.5px;
  text-underline-offset: 3px;
  color: #3f51b5;
  cursor: pointer;
`;
